import mitt, { Emitter } from 'mitt'
import { ChangeBackgroundEvent, LeavePageEvent } from './dashboard.types'

export const BackgroundEmitter: Emitter<ChangeBackgroundEvent> =
  mitt<ChangeBackgroundEvent>()
export const LeavePageEmitter: Emitter<LeavePageEvent> = mitt<LeavePageEvent>()
